module.exports = __webpack_public_path__ + "img/power.32b8d29c.svg";